import "./App.css";

function App() {
  return (
    <div className="App">
      <div className="container">
        <h1 className="title">🚀 Notes App</h1>
        <p className="subtitle">
          Your frontend is deployed successfully
        </p>

        <button className="btn">
          Get Started
        </button>
      </div>
    </div>
  );
}

export default App;